import React from 'react'
import IncidentPerAttribute from './IncidentPerAttribute'


const ValidIncidentsPerBroadCategory
 = () => {

    const monitorReport = false;

    return (
        <>
            <IncidentPerAttribute monitorReport={monitorReport} attributeType ="BROADCATEGORY" disaggregation = "sex" />
        </>
    
  )
}

export default ValidIncidentsPerBroadCategory
